export default [
  {
    key: 'question',
    label: 'field.question',
    type: 'text',
    rules: 'required',
  },
  {
    key: 'answer',
    label: 'field.answer',
    type: 'text',
    rules: 'required',
  },
]
